<template>
  <div class="">
    <button @click="redirectUser()" class="btn" :class="[inputValue == 1?'btn-primary':'btn-outline-primary']">حالت
      ادمین
    </button>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SwitchAdminToUser",
  data() {
    return {
      inputValue: 1
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin"
    })
  },
  methods: {
    redirectUser() {
      let value = this.inputValue == 1 ? 0 : 1

      this.inputValue = value
      localStorage.setItem("admin-view", value); // 1 => normal , 0 => user
      window.location.reload()
    }
  },
  mounted() {
    if (this.isAdmin && [null, undefined].indexOf(localStorage.getItem("admin-view")) > -1) {
      localStorage.setItem("admin-view", 1)
    }
    this.inputValue = localStorage.getItem("admin-view")
  }
}
</script>

<style scoped>

</style>